module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJUAAABKCAIAAAA9qIHiAAABFklEQVR4Ae3TAQ0AIAzEwIEM/PuEIOOSTkHT7tfcMx1rYLPkgX8D9bP/oH71sw3Y9O2vfrYBm7791c82YNO3v/rZBmz69lc/24BN3/7qZxuw6dtf/WwDNn37q59twKZvf/WzDdj07a9+tgGbvv3VzzZg07e/+tkGbPr2Vz/bgE3f/upnG7Dp21/9bAM2ffurn23Apm9/9bMN2PTtr362AZu+/dXPNmDTt7/62QZs+vZXP9uATd/+6mcbsOnbX/1sAzZ9+6ufbcCmb3/1sw3Y9O2vfrYBm7791c82YNO3v/rZBmz69lc/24BN3/7qZxuw6dtf/WwDNn37q59twKZvf/WzDdj07a9+tgGbvv3VzzZg07c/u98DHkABrUYdFPoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/28.png
// module id = BthY
// module chunks = 1